<template>
  <div class="pointe-layout">
    <!-- Header -->
    <header class="pointe-header">
      <div class="pointe-header-inner">
        <a href="https://www.brocheballet.com/" class="pointe-logo-link">
          <span class="pointe-logo-text">Broche Ballet</span>
        </a>
        <button class="mobile-menu-toggle" @click="menuOpen = !menuOpen" aria-label="Toggle menu">
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
        </button>
        <nav class="pointe-nav" :class="{ open: menuOpen }">
          <a href="https://www.brocheballet.com/" @click="menuOpen = false">Home</a>
          <router-link to="/pointe" @click.native="menuOpen = false">En Pointe</router-link>
          <router-link to="/pointe/self-assessment" @click.native="menuOpen = false">Self Assessment</router-link>
          <router-link v-if="isLoggedIn" to="/pointe/dashboard" class="nav-cta" @click.native="menuOpen = false">My Dashboard</router-link>
          <router-link v-else to="/pointe/apply" class="nav-cta" @click.native="menuOpen = false">Apply Now</router-link>
        </nav>
      </div>
    </header>

    <!-- Content -->
    <main class="pointe-main">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class="pointe-footer">
      <div class="pointe-footer-inner">
        <div class="footer-columns">
          <div class="footer-col">
            <p class="footer-label">En Pointe</p>
            <router-link to="/pointe">About the Program</router-link>
            <router-link to="/pointe/apply">Apply</router-link>
            <router-link to="/pointe/self-assessment">Self Assessment</router-link>
            <router-link to="/pointe/dashboard">My Dashboard</router-link>
          </div>
          <div class="footer-col">
            <p class="footer-label">Broche Ballet</p>
            <a href="https://www.brocheballet.com/">Home</a>
            <a href="https://www.brocheballet.com/contact">Contact</a>
            <a href="mailto:hello@brocheballet.com">hello@brocheballet.com</a>
          </div>
        </div>
        <div class="footer-bottom">
          <a href="https://www.instagram.com/brocheballet/" target="_blank" class="footer-social" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
          </a>
          <p class="footer-copyright">Copyright {{ new Date().getFullYear() }} Broche Ballet, LLC</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { auth } from '@/firebase'

export default {
  data () {
    return {
      menuOpen: false,
      isLoggedIn: false
    }
  },
  created () {
    auth.onAuthStateChanged(user => {
      this.isLoggedIn = !!user
    })
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fanwood+Text:ital@0;1&family=Quattrocento:wght@400;700&display=swap');

.pointe-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #faf9f7;
  font-family: 'Fanwood Text', Georgia, serif;
}

/* Header */
.pointe-header {
  border-bottom: 1px solid #e8e5e1;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
}

.pointe-header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pointe-logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.pointe-logo-text {
  font-family: 'Quattrocento', Georgia, serif;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: .04em;
}

.pointe-nav {
  display: flex;
  align-items: center;
  gap: 28px;
}

.pointe-nav a {
  font-family: 'Fanwood Text', Georgia, serif;
  font-size: 15px;
  color: #1a1a1a;
  text-decoration: none;
  letter-spacing: .02em;
  transition: color 0.15s;
}

.pointe-nav a:hover {
  color: #666;
}

.nav-cta {
  padding: 8px 18px;
  border: 1px solid #1a1a1a;
  transition: background 0.2s, color 0.2s !important;
}

.nav-cta:hover {
  background: #1a1a1a;
  color: #fff !important;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.hamburger-line {
  display: block;
  width: 22px;
  height: 1.5px;
  background: #1a1a1a;
}

/* Main */
.pointe-main {
  flex: 1;
}

/* Footer */
.pointe-footer {
  background: #1a1a1a;
  color: #ccc;
  margin-top: 60px;
}

.pointe-footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 24px 32px;
}

.footer-columns {
  display: flex;
  gap: 60px;
  margin-bottom: 32px;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-col a {
  font-family: 'Fanwood Text', Georgia, serif;
  font-size: 14px;
  color: #ccc;
  text-decoration: none;
  transition: color 0.15s;
}

.footer-col a:hover {
  color: #fff;
}

.footer-label {
  font-family: 'Quattrocento', Georgia, serif;
  font-size: 12px;
  font-weight: 700;
  color: #999;
  text-transform: uppercase;
  letter-spacing: .08em;
  margin: 0 0 4px 0;
}

.footer-bottom {
  border-top: 1px solid #333;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-social {
  color: #ccc;
  transition: color 0.15s;
}

.footer-social:hover {
  color: #fff;
}

.footer-copyright {
  font-family: 'Fanwood Text', Georgia, serif;
  font-size: 13px;
  font-style: italic;
  color: #888;
  margin: 0;
}

/* Mobile */
@media (max-width: 768px) {
  .pointe-header {
    position: relative;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .pointe-nav {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    flex-direction: column;
    padding: 16px 24px 24px;
    gap: 16px;
    border-bottom: 1px solid #e8e5e1;
    box-shadow: 0 4px 12px rgba(0,0,0,.06);
  }

  .pointe-nav.open {
    display: flex;
  }

  .footer-columns {
    flex-direction: column;
    gap: 32px;
  }
}
</style>
